import { useRef } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { resets } from '@ui/css';
import { SizeTransition } from '@utils/react';
import { useOpgavekompleksetEntry } from '../../../state/hook.entry.js';
import { list, item, revealTransitionDurationMs } from './_hints.style.js';
import { Hint } from './atom.hint.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

function Hints(props) {
  const currentAttempt = useOpgavekompleksetEntry({
    select: entry => entry?.data.tasks[props.taskEntryKey]?.state.attempts
  }) ?? 0;
  const latestHintRef = useRef(undefined);
  const currentHint = props.task.hints.find(it => it.showAtAttempt === currentAttempt);
  if (currentHint) {
    latestHintRef.current = currentHint.text;
  }
  const currentHints = props.task.hints.filter(it => it.showAtAttempt <= currentAttempt);
  const initialHints = useRef(currentHints);
  const withAnimation = Object.keys(currentHints).join(",") !== Object.keys(initialHints.current).join(",");
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(TransitionGroup, {
      component: "ol",
      className: list,
      "aria-hidden": true,
      children: currentHints.map((hint, index) => /*#__PURE__*/jsx(SizeTransition, {
        axis: "vertical",
        timeout: {
          enter: revealTransitionDurationMs,
          exit: 0
        },
        classNames: item,
        children: ref => /*#__PURE__*/jsx("li", {
          ref: ref,
          className: item,
          children: /*#__PURE__*/jsx(Hint, {
            highlighted: hint.showAtAttempt === currentAttempt,
            text: hint.text,
            index: index,
            withAnimation: withAnimation
          })
        })
      }, index))
    }), /*#__PURE__*/jsx("div", {
      role: "status",
      className: resets.screenReaderOnlyCls,
      "data-disable-polly": true,
      children: latestHintRef.current
    })]
  });
}

export { Hints };
//# sourceMappingURL=_hints.js.map
